<div *ngIf="lineItem" class="card mb-5 mb-md-4 bg-dark border-0">
  <div class="row g-0">
    <div class="col-12 col-lg-2">
      <app-catalog-graphic imageClasses="card-img bg-white border my-3 ms-4"
                           [imageId]="imageId"
                           [imageSize]="80">
      </app-catalog-graphic>
    </div>
    <div class="col-12 col-lg-5 col-xl-6">
      <div class="card-body">
        <p class="card-text vendor-name mb-1">{{ vendorName }}</p>
        <p class="product-name mb-3">{{ name }}</p>
        <p class="card-text">
          <strong>Platform:</strong>
          {{ platformTitle }}
        </p>
        <p class="card-text"><strong>Version: </strong>{{ version }}</p>
        <p class="card-text">
          <strong>License Type:</strong>
          {{ licenseType | titlecase }}
        </p>
        <p class="card-text">
          <strong>Install Type:</strong>
          {{ usageType | underscoreToSpace | titlecase }}
        </p>
        <p *ngIf="!!endDate && !hasPerpetualLicense" class="card-text mb-2">
          <strong>License Term:</strong>
          {{ startDate | date:'mediumDate' }} - {{ endDate | date:'mediumDate' }}
        </p>
        <p *ngIf="hasPerpetualLicense" class="card-text mb-2">
          <strong>License Term:</strong>
          Perpetual License
        </p>
        <p *ngIf="editable" class="card-text mb-1"><strong>Platform:</strong> {{ platformTitle }}</p>
        <p *ngIf="editable && hasUpgradeProtection" class="card-text mb-1">Includes Maintenance</p>
        <p *ngIf="editable && isUpgradeProtectionOnly" class="card-text mb-1">Maintenance Only</p>
      </div>
    </div>
    <div class="col-12 col-lg-5 col-xl-4 cart-item-qty">
      <form [formGroup]="quantityForm">
        <dl class="px-md-4 ms-5 ms-md-0 pt-md-2">
          <div class="row align-items-center mt-3 mb-2 mb-md-4">
            <dt class="col-5 text-end mx-auto">Price</dt>
            <dd class="col-7 text-xl-end cart-price mx-auto">{{ individualPrice | currency }}</dd>
          </div>
          <div class="row align-items-center mb-2 mb-md-4">
            <dt class="col-5 text-end">
              <label for="quantity{{item.id}}">Qty</label>
            </dt>
            <dd class="col-7 text-xl-end cart-price mx-auto d-flex justify-content-xl-end justify-content-start"
                *ngIf="editable; else displayOnlyBlock">
              <input id="quantity{{item.id}}"
                     type="number"
                     aria-label="Quantity"
                     formControlName="quantity"
                     class="qty form-control px-2 text-xl-end">
            </dd>
            <ng-template #displayOnlyBlock>
              <dd class="col-7 text-xl-end cart-price mx-auto">{{ item?.quantity }}</dd>
            </ng-template>
          </div>
          <div class="row align-items-center">
            <dt class="col-5 text-end mx-auto">Subtotal</dt>
            <dd class="col-7 text-xl-end cart-price mx-auto">{{ item?.price | currency }}</dd>
          </div>
        </dl>
      </form>
      <div class="col-12 mb-3 d-grid px-3">
        <button *ngIf="editable" [attr.disabled]="processing ? true : null" (click)="remove()"
                class="btn btn-dark p-3 p-lg-2">Remove From Cart
        </button>
      </div>
    </div>
    <div *ngIf="serialNumbers && serialNumbers.length" class="offset-1 col-md-8 mb-md-3">
      <strong>Serial Number<span *ngIf="serialNumbers.length > 1">s</span>
        <div *ngFor="let sn of serialNumbers">
          {{ sn }}
        </div>
      </strong>
    </div>
  </div>
  <app-license-expiration-warning *ngIf="hasEditableOffering"
                                  [offerings]="offerAsArray"></app-license-expiration-warning>
</div>
